import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Helmet } from "react-helmet";
import web5 from "../img/aboutus.jpg";
import "../style/styles.css";
import "../style/About.css";

const About = () => {
  const alText = "photo";

  const serviceItems = [
    "The installation and implementation of the software",
    "Project management of the implementation process",
    "Training of management and staff",
    "Site customization and software development to meet specific requirements",
    "Ongoing provision of software upgrades and support",
    "Scheduled training courses",
  ];

  const highlightCards = [
    {
      value: "GST",
      label: "Supported Software",
    },
    {
      value: "80%",
      label: "Cost Saving on Integration",
    },
    {
      value: "ERP",
      label: "Business Solutions",
    },
    {
      value: "Support",
      label: "Training & Upgrade",
    },
  ];

  const capabilityCards = [
    {
      title: "Business Software Solutions",
      text:
        "We offer business software solutions for modern market needs and have created practically every kind of business software to meet the demands of various markets.",
    },
    {
      title: "Implementation & Training",
      text:
        "We provide comprehensive solutions covering installation, training, implementation, modification, upgrading and other services.",
    },
    {
      title: "GST Compliance",
      text:
        "Our software supports GST, e-Way Bills, GST returns, GSTR-1, GSTR-3B and GSTR-4 returns with Excel export options.",
    },
    {
      title: "IT Infrastructure",
      text:
        "IT infrastructure software helps people and systems connect efficiently, share information and manage business touch points across the enterprise.",
    },
  ];

  const handleImageError = (event) => {
    event.currentTarget.style.display = "none";
  };

  return (
    <main className="about-detail-page">
      <Helmet>
        <meta charSet="utf-8" />
        <title>About Us | EBS Software Solution</title>
        <meta
          name="description"
          content="About EBS Software Solution, Siliguri, West Bengal, India. Business software solutions, GST supported software, IT infrastructure software, installation, implementation, training, customization, upgrades and support."
        />
      </Helmet>

      <section className="about-hero">
        <div className="about-hero-overlay"></div>

        <Container className="about-hero-container">
          <Row className="align-items-center g-4">
            <Col lg={7}>
              <div className="about-hero-content">
                <div className="about-kicker">About EBS Software Solution</div>
                <h1>About Us</h1>
                <p>
                  Located in Siliguri, West Bengal (India), EBS SOFTWARE
                  SOLUTION is a well-known provider of software solutions. For
                  every need that the modern business market has, we offer
                  business software solutions.
                </p>
              </div>
            </Col>

            <Col lg={5}>
              <div className="about-hero-card">
                <span>Reliable Software Partner</span>
                <strong>Business Software, GST, ERP & IT Infrastructure</strong>
                <p>
                  Installation, training, implementation, customization,
                  upgrading and ongoing support for business software solutions.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="about-stats-section">
        <Container>
          <Row className="g-3">
            {highlightCards.map((item) => (
              <Col lg={3} md={6} key={item.label}>
                <div className="about-stat-card">
                  <strong>{item.value}</strong>
                  <span>{item.label}</span>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section className="about-intro-section">
        <Container>
          <Row className="g-4 align-items-center">
            <Col lg={6}>
              <div className="about-section-label">Company Overview</div>
              <h2 className="about-section-title">
                Dependable software solutions for modern businesses
              </h2>

              <p className="about-text">
                Located in Siliguri, West Bengal (India), EBS SOFTWARE SOLUTION
                is a well-known provider of software solutions. For every need
                that the modern business market has, we offer business software
                solutions. We have created practically every kind of business
                software to meet the demands of various markets.
              </p>

              <p className="about-text">
                We take great pride in providing our software to the public and
                private domains.To ensure our clients are satisfied, we offer
                comprehensive solutions that cover installation, training,
                implementation, modification, upgrading, and other services. Our
                software is specifically designed to meet the needs of our
                esteemed clients.
              </p>
            </Col>

            <Col lg={6}>
              <div className="about-image-card">
                <img
                  className="about-main-image"
                  src={web5}
                  alt={alText}
                  onError={handleImageError}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="about-content-section">
        <Container>
          <Row className="g-4">
            <Col lg={7}>
              <div className="about-content-card">
                <div className="about-section-label">Our Approach</div>
                <h2>Client-focused software development and support</h2>

                <p>
                  In order to assist our clients in finding the ideal balance
                  between price and quality, our top-notch management team is
                  always honing its methods and strategies. We also eagerly
                  await the contractual portion of a business agreement in order
                  to identify the "softer" issues that have an impact on our
                  clients&apos; success.
                </p>

                <p>
                  Maybe this explains why repeat customers account for the
                  majority of our business. They believe that even though we are
                  not the biggest, we are the best partner to help them achieve
                  their goals.
                </p>

                <p>
                  GST is supported in our software. It assists you in filling
                  out your returns automatically according to the kind and
                  amount of transactions. It is simple for a user to generate
                  e-Way Bills, file GST returns, and create transactions that
                  comply with GST laws.
                </p>

                <p>
                  While a composite dealer can use our software to file GSTR-4
                  returns, regular dealers can only file GSTR-1 and GSTR-3B
                  returns. You can export each of these forms in Excel format.
                </p>
              </div>
            </Col>

            <Col lg={5}>
              <div className="about-capability-grid">
                {capabilityCards.map((item) => (
                  <div className="about-capability-card" key={item.title}>
                    <span>✓</span>
                    <h3>{item.title}</h3>
                    <p>{item.text}</p>
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="about-infra-section">
        <Container>
          <Row className="g-4 align-items-start">
            <Col lg={5}>
              <div className="about-infra-title">
                <div className="about-section-label">
                  IT Infrastructure Software
                </div>
                <h2 className="about-section-title">
                  Enterprise connectivity, integration and process support
                </h2>
              </div>
            </Col>

            <Col lg={7}>
              <div className="about-infra-card">
                <p>
                  IT infrastructure software is used to make sure that people and
                  systems in your organization can connect to efficiently
                  execute business processes, share information, and manage
                  touch points with customers and suppliers.
                </p>

                <p>
                  Infrastructure software dynamically detects relationships
                  between resources and helps coordinate activities across an
                  entire enterprise. IT infrastructure can also be configured to
                  automatically alert users to relevant discoveries and best
                  practices, based on their current activity and without
                  requiring a user-initiated search.
                </p>

                <p>
                  When compared to custom-coded integration, EBS SOFTWARE
                  SOLUTION integration solutions save up to 80% on costs and
                  enable faster project implementations thanks to their
                  plug-and-play design and openness. Additionally, they save a
                  significant amount of maintenance costs because candidates can
                  communicate with the standardized integration architecture of
                  EBS Software rather than confusing "hard-coded" back-office
                  system connections.
                </p>

                <p>
                  EBS Software is the best value available today for the
                  following reasons: it hides the complexity of enterprise IT
                  environments, allowing resources to be mobilized to support the
                  implementation of new business ideas more quickly than you ever
                  would have imagined.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="about-services-section">
        <Container>
          <div className="about-services-card">
            <Row className="g-4 align-items-center">
              <Col lg={5}>
                <div className="about-section-label">Complete Service</div>
                <h2>In addition, EBS Software offers a complete service</h2>
                <p>
                  Our services cover the complete journey from implementation to
                  training, customization, upgrades and continuing support.
                </p>
              </Col>

              <Col lg={7}>
                <div className="about-service-list">
                  {serviceItems.map((item) => (
                    <div key={item}>
                      <span>✓</span>
                      <p>{item}</p>
                    </div>
                  ))}
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </section>
    </main>
  );
};

export default About;
